'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VerticalTimeline = function (_Component) {
  _inherits(VerticalTimeline, _Component);

  function VerticalTimeline() {
    _classCallCheck(this, VerticalTimeline);

    return _possibleConstructorReturn(this, (VerticalTimeline.__proto__ || Object.getPrototypeOf(VerticalTimeline)).apply(this, arguments));
  }

  _createClass(VerticalTimeline, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          animate = _props.animate,
          children = _props.children;
      var className = this.props.className;


      className += ' vertical-timeline';

      if (animate) {
        className += ' vertical-timeline--animate';
      }

      return _react2.default.createElement(
        'div',
        { className: className.trim() },
        children
      );
    }
  }]);

  return VerticalTimeline;
}(_react.Component);

VerticalTimeline.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired,
  className: _propTypes2.default.string,
  animate: _propTypes2.default.bool
} : {};

VerticalTimeline.defaultProps = {
  animate: true,
  className: ''
};

exports.default = VerticalTimeline;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-vertical-timeline-component/dist-modules/VerticalTimeline.js
 ** module id = 681
 ** module chunks = 0
 **/